module.exports = __webpack_public_path__ + "static/plotly-3d28946f58c6ccbc28bfe03f45b2973d.png";